// i18n runtime config for @nuxtjs/i18n v9
// Replaces old vueI18n: { fallbackLocale: 'en' } inline option
export default defineI18nConfig(() => ({
  fallbackLocale: 'en',
}))
